export const REQUIRES_FIELDS = [
    {key: "weight", label: "Peso"},
    {key: "needed_weight", label: "Peso oblig."},
    {key: "dirt", label: "Bolseo"},
    {key: "needed_dirt", label: "Bolseo oblig."},
    {key: "gps", label: "GPS"},
];

export const DEFAULT_REQUIRES = {
    weight: false,
    needed_weight: false,
    dirt: false,
    needed_dirt: false,
    gps: false,
};
